import type { WorkspaceEntityStore } from './registry';
import { workspaceRuntime } from '#layers/runtime/workspace/runtime';
import { createWorkspaceHydrationDefiner } from './define-workspace-hydration';

/**
 * Workspace queries that stores derive from: hydrated per candidate runtime, read from the active one.
 * The definition owns the rstore query; the seam owns only its runtime lifetime (ADR 051).
 */
export const defineWorkspaceHydration = createWorkspaceHydrationDefiner<WorkspaceEntityStore>(workspaceRuntime);
